enum Action {
  REMOVE_EVALUATIONS_BY_STAFF_SHIFT_ID = 'removeEvaluationsByStaffShiftId',
  FETCH_EVALUATION = 'fetchEvaluation',
  CREATE_EVALUATION = 'createEvaluation',
  ACCEPT_EMPLOYMENT_EVALUATION = 'acceptEmploymentEvaluation',
}

export default Action;
